import React from 'react';
import classnames from 'classnames';
import { Config } from '@leverege/plugin';
import { Pane, Text, Dialogs, Dialog } from '@leverege/ui-elements';
import { PuffLoader } from 'react-spinners';
import S from './LoadingView.css';

/**
 * Returns a loading view.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LoadingView(props) {
  const Loader = Config.get('LoadingView', 'spinner', PuffLoader);
  const loaderProps = Config.get('LoadingView', 'props', {});
  const {
    variant = 'loadingView|loadingScreen',
    inline,
    inlineSize = loaderProps.inlineSize || 20,
    className,
    size = loaderProps.size || 30,
    color,
    title,
    children,
    subchildren
  } = props;
  if (inline === true) {
    return /*#__PURE__*/_jsx(Loader, {
      size: inlineSize,
      color: color || 'var( --color-loader, var( --color-brand200, #dedede ) )'
    });
  }
  return /*#__PURE__*/_jsxs(Pane, {
    className: classnames(S.content, className),
    variant: variant,
    children: [children, /*#__PURE__*/_jsx(Loader, {
      size: size,
      color: color || 'var( --color-loader, var( --color-brand200, #dedede ) )'
    }), title && /*#__PURE__*/_jsx(Text, {
      variant: "loadingView|loadingScreen|subTitle",
      children: title
    }), subchildren]
  });
}

/**
 * An inline version of the loader
 */
LoadingView.Inline = function ({
  size = 20
}) {
  return /*#__PURE__*/_jsx(LoadingView, {
    inline: true,
    inlineSize: size
  });
};

/**
 * Presents a Dialog with the LoadingView and title.
 * @returns a close function to dismiss the dialog
 */
LoadingView.showDialog = title => {
  return Dialogs.show({
    component: Dialog,
    props: {
      closeOnEscape: false,
      closeOnDocumentClick: false,
      children: /*#__PURE__*/_jsx(LoadingView, {
        variant: "dialog",
        title: title
      })
    }
  });
};